<!-- 导航组件 -->
<template>
  <div class="head">
    <div class="nav">
      <div class="nav_li" :class="newNav==1?'active_li':''" @click="changeNav(1)">
        <span class="nav_a">绿茶首页</span>
      </div>
      <div class="nav_li" :class="newNav==2?'active_li':''" @click="changeNav(2)">
        <span class="nav_a">软件产品</span>
      </div>
      <div class="nav_li" :class="newNav==3?'active_li':''" @click="changeNav(3)">
        <span class="nav_a">成功案例</span>
      </div>
      <div class="nav_li" :class="newNav==4?'active_li':''" @click="changeNav(4)">
        <span class="nav_a">关于我们</span>
      </div>
    </div>
    <van-popup class="headPopup" v-model="showNav" position="top" :lock-scroll="true" :safe-area-inset-bottom="true" :duration="0.2">
      <div class="navBar">
        <div class="item">
          <div class="title">知识付费/IM</div>
          <div class="link">
            <span @click="toLink(1)">教育O2O</span>
            <span @click="toLink(2)">知识付费</span>
            <span @click="toLink(3)">IM社交</span>
            <span @click="toLink(4)">IM社群营销</span>
          </div>
        </div>
        <div class="item">
          <div class="title">直播系统</div>
          <div class="link">
            <span @click="toLink(5)">直播+短视频</span>
            <span @click="toLink(6)">互动直播</span>
            <span @click="toLink(7)">短视频</span>
            <span @click="toLink(8)">短视频社交</span>
          </div>
        </div>
        <div class="item">
          <div class="title">社交电商</div>
          <div class="link">
            <span @click="toLink(9)">会员制社交</span>
            <span @click="toLink(10)">社群分享型社交</span>
            <span @click="toLink(11)">拼购类社交</span>
            <span @click="toLink(12)">营销插件</span>
            <span @click="toLink(13)">前置仓电商</span>
            <span @click="toLink(14)">城市O2O</span>
            <span @click="toLink(15)">社区O2O</span>
            <span @click="toLink(16)">社区团购</span>
          </div>
        </div>
        <div class="item">
          <div class="title">刷脸支付</div>
          <div class="link">
            <span @click="toLink(17)">刷脸支付</span>
            <span @click="toLink(18)">聚优客商圈</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";

import { Popup } from "vant";
Vue.use(Popup);
export default {
  data() {
    return {
      newNav: 1,
      showNav: false,
    };
  },
  mounted() {
    let vm = this;
    let name = vm.$route.name;
    if (name == "index") {
      vm.newNav = 1;
    } else if (name == "case") {
      vm.newNav = 3;
    } else if (name == "about") {
      vm.newNav = 4;
    } else {
      vm.newNav = 2;
    }
  },

  methods: {
    // 主页面跳转
    changeNav(index) {
      let vm = this;

      switch (index) {
        case 1:
          vm.init(index, "index");
          break;
        case 2:
          vm.showNav = !vm.showNav;
          // vm.$router.push({ name: "product" });
          break;
        case 3:
          vm.init(index, "case");
          break;
        case 4:
          vm.init(index, "about");
          break;
      }
    },
    init(index, name) {
      let vm = this;
      vm.newNav = index;
      vm.showNav = false;
      window.scrollTo(0, 0);
      vm.$router.push({ name: name });
    },

    // 子页面跳转
    toLink(index) {
      let vm = this;
      switch (index) {
        case 1:
          vm.toLinkCom("education");
          break;
        case 2:
          vm.toLinkCom("knowledgePay");
          break;
        case 3:
          vm.toLinkCom("socialSystem");
          break;
        case 4:
          vm.toLinkCom("marketingSystem");
          break;
        case 5:
          vm.toLinkCom("sinatv");
          break;
        case 6:
          vm.toLinkCom("interactionLive");
          break;
        case 7:
          vm.toLinkCom("shortVideo");
          break;
        case 8:
          vm.toLinkCom("socialContact");
          break;
        case 9:
          vm.toLinkCom("memberContact");
          break;
        case 12:
          vm.toLinkCom("marketing");
          break;
        case 13:
          vm.toLinkCom("warehouse");
          break;
        case 14:
          vm.toLinkCom("cityoto");
          break;
        case 15:
          vm.toLinkCom("community");
          break;
        case 16:
          vm.toLinkCom("groupBuying");
          break;
        case 17:
          vm.toLinkCom("brushFace");
          break;

        case 18: // 商圈
          window.location.href = "https://www.juyouke.cc";
          break;

        default:
          vm.toLinkCom("ongoing");
      }
    },

    toLinkCom(name) {
      let vm = this;
      vm.$router.push({ name: name });
      vm.showNav = false;
      vm.newNav = 2;
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang='less' scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2000;
  .nav {
    background-color: #f5f5f5;
    height: 1.45rem;
    display: flex;
    font-size: 0.4rem;
    align-items: center;
    padding: 0 0.3rem;
    position: absolute;
    width: 100%;
    z-index: 3000;
    .nav_li {
      flex: 1;
      text-align: center;
      .nav_a {
        color: #000;
        transition: all 0.2s;
      }
    }
    .active_li {
      .nav_a {
        color: #2fa356;
      }
    }
  }
}
.navBar {
  .item {
    .title {
      font-size: 0.4rem;
      text-align: center;
      line-height: 1.4rem;
      color: #47bc6e;
    }
    .link {
      background-color: #192030;
      display: flex;
      flex-wrap: wrap;
      span {
        font-size: 0.34rem;
        color: #fff;
        line-height: 0.6rem;
        padding: 0.3rem 0;
        width: 25%;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/conHeader.vue